
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable ({
    providedIn: 'root'
})
export class HttpClientInterceptor implements HttpInterceptor {

    constructor(private permissionService: PermissionService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log("HttpClientInterceptor.intercept() - req URL: " + req.url);
        let applicationComponent: string;
        let clientUuidHeaderName: string;
        let clientUuid: string;
        if (req.url.indexOf(environment.buildingsBackendMembershipAddress) > -1) {
            clientUuid = environment.buildingsMembershipClientAccessUuidToken;
            clientUuidHeaderName = environment.buildingsMembershipclientAccessUuidTokenName;
            applicationComponent = "buildingsMembership";
        } else if (req.url.indexOf(environment.buildingsBackendDossierAddress) > -1) {
            clientUuid = environment.buildingsDossierClientAccessUuidToken;
            clientUuidHeaderName = environment.buildingsDossierclientAccessUuidTokenName;
            applicationComponent = "buildingsDossier";
        } else {
            // console.log("HttpClientInterceptor - ATTENTION: no client-uuid found... bypass headers population");
            applicationComponent = "";
            clientUuid = "";
            clientUuidHeaderName = "";
            return next.handle(req);
        }

        let userRoles: string | undefined = this.permissionService.getClientUserRoles()?.join(',').trim();
        // console.log("HttpClientInterceptor - User Roles Found: " + userRoles);
        
        if(!userRoles || userRoles.length === 0) {
            // console.log("HttpClientInterceptor - ATTENTION: NO CLIENT USER ROLES FOUND ...");
            userRoles = "";
        }

        let activeLegalEntityId: number = this.permissionService.getClientUserActiveLegalEntity()?.id ?? 0;
        // console.log("HttpClientInterceptor - Active Legal Entity ID Found: " + activeLegalEntityId);

        return from(this.permissionService.getEncryptedClientDeviceFingerprint(applicationComponent, activeLegalEntityId))
        .pipe(
            switchMap((data: {encyptedFingerprint: string, encryptedActiveLegalEntityId: string}) => {
                // console.log("HttpClientInterceptor.intercept() - Client UUID: " + clientUuid + ". Client Device Id: " + fingerprint);
                if(activeLegalEntityId && activeLegalEntityId > 0) {
                    req = req.clone({
                        withCredentials: true,
                        headers: req.headers.append(clientUuidHeaderName, clientUuid)
                        .append(environment.userRolesHeaderName, userRoles)
                        .append(environment.clientFingerprintHeaderName, data.encyptedFingerprint)
                        .append(environment.activeLegalEntityEncryptedIdHeaderName, data.encryptedActiveLegalEntityId)
                    });
                    // console.log("HttpClientInterceptor.intercept() - headers: " + req.headers.keys() + " - " + req.headers.get(environment.clientFingerprintHeaderName) + " - " + req.headers.get(environment.activeLegalEntityEncryptedIdHeaderName)
                    // + " - " + req.headers.get(environment.userRolesHeaderName) + " - " + req.headers.get(clientUuidHeaderName));
                } else {
                    req = req.clone({
                        withCredentials: true,
                        headers: req.headers.append(environment.userRolesHeaderName, userRoles)
                        .append(clientUuidHeaderName, clientUuid)
                        .append(environment.clientFingerprintHeaderName, data.encyptedFingerprint)
                    });
                    // console.log("HttpClientInterceptor.intercept() - headers: " + req.headers.keys() + " - " + req.headers.get(environment.clientFingerprintHeaderName)
                    // + " - " + req.headers.get(environment.userRolesHeaderName) + " - " + req.headers.get(clientUuidHeaderName));
                }
                
                //console.log("COOKIE WINO AUTH TOKEN: " + this.cookieService.get("winoAuthToken"));

                //console.log("AUTH INTERCEPTOR");
                //this.permissionService.checkAuthentication();
                
                //const token = this.cookieService.getAccessToken();
                    
                // console.log('JWT TOKEN: ' + token);
                // console.log('Access Token: ' + httpRequest.urlWithParams);
                // console.log('Http Request: ' + httpRequest.body);

                return next.handle(req);
            })
        );
    }
}